import { CreateApplicationFormValue } from '@dev-portal/models/create-application-form';
import { CreateApplicationData } from '@dev-portal/models/create-application-data';

export class CreateApplicationFormMapper {
  static toCreateApplicationData(fv: CreateApplicationFormValue): CreateApplicationData {
    return { name: fv.name! };
  }
}
